export default __webpack_public_path__ + "assets/models/6f357f932585ccef57b9961bf02a33c6.glb";